<template>
    <Card>
        <div class="card-body">
            <router-link
                class="btn btn-link"
                :to="{
                    name: 'OrderDeliveriesCreatePage'
                }"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <FetchTable :handle="tableHandle" :columns="table.columns" :url="table.url" v-model:orders="table.orders">
            <template #td-id="{row}">
                <router-link
                    :to="{
                        name: 'OrderDeliveriesEditPage',
                        params: {
                            deliveryUuid: row.uuid
                        }
                    }"
                >
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-method="{row}">
                {{ showDeliveryIntegration(row.method) ?? row.method_label }}
            </template>
            <template #td-company_number="{row}">
                <DeliveryTtnBlock v-if="row.company_number" :company-number="row.company_number" :sticker-file="row.sticker_file" :waybill-file="row.waybill_file" />
                <AppNullableCell v-else />
            </template>
            <template #td-delivery_status="{row}">
                <AppNullableCell>
                    <template #default v-if="row.status_label">
                        <span class="long-string">{{ row.status_label }}</span>
                    </template>
                </AppNullableCell>
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import AlphaButton from "../../../../../components/new/button/AlphaButton.vue";
import DateFormatter from "../../../../../services/DateFormatter";
import FetchTable from "../../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../../components/new/table/tableHandle";
import AppNullableCell from "../../../../components/tables/AppNullableCell.vue";
import DeliveryTtnBlock from "../../../../components/tables/DeliveryTtnBlock.vue";

import { showDeliveryIntegration } from "../../../../enums/DeliveryIntegrationsEnum";

export default {
    name: "DeliveriesIndexPage",
    components: {
        Card, AlphaButton, FetchTable, AppNullableCell, DeliveryTtnBlock
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            showDeliveryIntegration,
            DateFormatter,
            table: {
                url: `/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/deliveries`,
                orders: [],
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '100px', type: 'string', order: false},
                    {key: 'method', name: this.$t('table.titles.method'), width: '150px', type: 'string', order: false},
                    {key: 'address', name: this.$t('table.titles.address'), width: '300px', type: 'string', order: false},
                    {key: 'delivery_status', name: this.$t('table.titles.delivery_status'), width: '300px', type: 'string', order: false},
                    {key: 'company_number', name: this.$t('table.titles.company_number'), width: '200px', type: 'string', order: false},
                    {key: 'recipient_name', name: this.$t('table.titles.recipient_name'), width: '200px', type: 'string', order: false},
                    {key: 'recipient_phone', name: this.$t('table.titles.recipient_phone'), width: '200px', type: 'string', order: false},
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows({
            order_uuid: this.$route.params.orderUuid
        });
    }
}
</script>
<style scoped>
.long-string {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>